import NAME from "./constants";

export const GET_ROWS = NAME + "/GET_ROWS";
export const GET_ROWS_FULFILLED = NAME + "/GET_ROWS_FULFILLED";
export const GET_ROWS_REJECTED = NAME + "/GET_ROWS_REJECTED";

export const GET_BASIC_ELEMENTS = NAME + "/GET_BASIC_ELEMENTS";
export const GET_BASIC_ELEMENTS_FULFILLED = NAME + "/GET_BASIC_ELEMENTS_FULFILLED";
export const GET_BASIC_ELEMENTS_REJECTED = NAME + "/GET_BASIC_ELEMENTS_REJECTED";